import { createFileRoute } from '@tanstack/react-router';
import { Permission } from '../../../features/common/permision';
import { VideoCreateMultiImage } from './reference-create';

export const Route = createFileRoute(
  '/_creator-center/video/long/reference-create',
)({
  staticData: { permissions: [Permission.视频生成] },
  component: () => (
    <VideoCreateMultiImage isLongVideoSupported></VideoCreateMultiImage>
  ),
});
